import React, { useEffect, useState, useMemo } from "react";
//import { dateTimeFormat } from "../../utils/helper";

//import { v4 as uuid } from 'uuid';

import axios from 'axios';

import { useAppSelector } from "../../store/hooks";
import { RootState, useAppDispatch } from "../../store";

import { getShiftUserList, getShiftLogList } from "../../store/shift/shiftSlice";

import SharedDialog from "../../components/shared/SharedDialog";
import { SharedDialogActions } from "../../store/components/sharedDialogSlice";

import { useNotification } from "../../resources/useNotification";

// Import material UI componensts
import { styled } from '@mui/material/styles';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';

//import AddIcon from "@mui/icons-material/Add";
//import Table from "@mui/material/Table";
//import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
//import TableContainer from "@mui/material/TableContainer";
//import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
//import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import Checkbox from "@mui/material/Checkbox";
import RefreshIcon from '@mui/icons-material/Refresh';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import Card from "@mui/material/Card";
//import CardActions from "@mui/material/CardActions";
import CardHeader from '@mui/material/CardHeader';
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
//import Container from "@mui/material/Container";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';

import { createStyles, makeStyles } from "@mui/styles";

import ReactJson from 'react-json-view'; // Import React JSON Viewer

import { queryTableItems, fetchShiftUsers, handoverDataToSSMIncidentManager, createLogItem, fetchAllLogs } from '../../services/AwsFunctions';


//MRT Imports
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export type Employee = {
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
  salary: number;
  startDate: string;
  signatureCatchPhrase: string;
  avatar: string;
};

import _ from "lodash";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#00275A",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const isIndeterminate = (indeterminate: any) => indeterminate;
const selectableRowsComponentProps = { indeterminate: isIndeterminate };

const useStyles = makeStyles({
  card: {
    minWidth: 275,
    //border: "1px solid #c6c6c6",
    //padding: "10px",
    boxShadow: "0rem 0.1rem 0.5rem rgba(0, 0, 0, 0.2)",
    minHeight: 250,
    height: "100%"
  },
  cardHeader: {
    backgroundColor: "#01275A",
  },
  cardHeaderTitle: {
    color: "#fff",
    fontWeight: "400",
    fontSize: "1.1rem",
    textTransform: "uppercase"
  },
  cardSubHeader: {
    color: "#fff",
    fontSize: "0.9rem !important",
  },
  actionBtn1: {
    backgroundColor: "#ff9100",
    fontWeight: 400,
    '&:hover': {
      background: "#ff9100",
    },
  },
})

type Log = {
  LOG_ID: string;
  LOG_DATETIME: string;
  CREATED_AT: string;
  HANDOVER_BY: string;
  LOG_DETAILS: string;
  SHIFT_OVERWRITE: string;
  NOTES: string;
  SHIFT_FROM: string;
  SHIFT_TO: string;
  TICKETS_LOG: string;
  ALARM_LOG: string;
};

const SHIFT_TIMINGS = [
  {
    "shiftName": "Morning",
    "startTime": "07:00 AM",
    "endTime": "03:00 PM",
    "shiftSequence": "A",
    "visibility": true,
    "displayOrder": 1
  },
  {
    "shiftName": "Afternoon",
    "startTime": "02:00 PM",
    "endTime": "10:00 PM",
    "shiftSequence": "B",
    "visibility": true,
    "displayOrder": 2
  },
  {
    "shiftName": "Night",
    "startTime": "10:00 PM",
    "endTime": "07:00 AM",
    "shiftSequence": "C",
    "visibility": true,
    "displayOrder": 3
  },
  {
    "shiftName": "General",
    "startTime": "",
    "endTime": "",
    "shiftSequence": "D",
    "visibility": true,
    "displayOrder": 4
  },
  {
    "shiftName": "Week - OFF",
    "startTime": "",
    "endTime": "",
    "shiftSequence": "E",
    "visibility": false,
    "displayOrder": 5
  },
  {
    "shiftName": "Week - OFF",
    "startTime": "",
    "endTime": "",
    "shiftSequence": "F",
    "visibility": false,
    "displayOrder": 6
  },
  {
    "shiftName": "COMP - OFF",
    "startTime": "",
    "endTime": "",
    "shiftSequence": "G",
    "visibility": false,
    "displayOrder": 7
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function Dashboard() {
  const classes = useStyles();
  
  //State to store the values
  const [logTableData, setLogTableData] = useState([]);

  const [loading, setLoading] = React.useState<boolean>(true);

  const [shiftList, setShiftList] = useState([]);
  const [users, setUsers] = useState([]);

  const dispatch = useAppDispatch();
  const { data, isLoading, error } = useAppSelector((state: RootState) => state.shift.logList);

  const [openLogDialog, setOpenLogDialog] = useState(false); // Dialog visibility
  const [selectedLogRow, setSelectedLogRow] = useState(null); // Store selected row data

  // Get the current date
  const currentDate = new Date();

  // Get year, month, and day components
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');

  // Form the "dd/mm/yyyy" date string
  const formattedDate = `${day}/${month}/${year}`;

  const fetchShiftList = () => {
    
    queryTableItems('SK-OnCall-Handover-Logs', formattedDate).then((logItems: any) => { //SK-ShiftRoster-Logs
      console.log('LOG ITEMS: ', logItems, formattedDate);
      let shiftLogItem: any = {}
      if (logItems.length > 0) {
        shiftLogItem = logItems[0];
      }
      
      queryTableItems('SK-ShiftRoster', formattedDate).then((items: any) => {
        const shiftRosterItem = items[0]
        // console.log('SHIFT ITEM: ', shiftList);

        console.log('Roster Data: ', shiftRosterItem)
  
        let shiftList = [];
        for (let key in shiftRosterItem) {
          if (shiftRosterItem.hasOwnProperty(key)) {
            if (key.includes("Shift")) {
                const splitShift = key.split(" ");
                
                let shiftTiming: any = SHIFT_TIMINGS.filter(o => o.shiftName.includes(shiftRosterItem[key]));
                let shiftStartTime = "";
                let shiftEndTime = "";
                let displayOrder = 0;

                if (shiftTiming.length > 0) {
                  shiftStartTime = shiftTiming[0]['startTime'];
                  shiftEndTime = shiftTiming[0]['endTime'];
                  displayOrder = shiftTiming[0]['displayOrder'];
                }
                
                let isHandover = false;
                if (Object.keys(shiftLogItem).length !== 0 && shiftLogItem.ShiftFrom === splitShift[1]) {
                  isHandover = true;
                }
                
                shiftList.push({'shiftName': shiftRosterItem[key], 'shift': splitShift[1], 'shiftStartTime': shiftStartTime, 'shiftEndTime': shiftEndTime, 'isHandover': isHandover, 'displayOrder': displayOrder})
              }
          }
        }

        // console.log('SHIFT LIST 1:', shiftList);
  
        shiftList = shiftList.sort((a, b) => {
          let fa = a.shift, fb = b.shift;
      
          if (fa < fb) {
              return -1;
          }
          if (fa > fb) {
              return 1;
          }
          return 0;
        });

        /* shiftList = shiftList.reduce((result, currentValue) => {
          if (currentValue['shiftName'] !== undefined) {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue['shiftName']] = result[currentValue['shiftName']] || []).push(
              currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
          }
          
        }, {}); */

        /* shiftList = shiftList.reduce(function (r, a) {
            r[a.shiftName] = r[a.shiftName] || [];
            r[a.shiftName].push(a);
            return r;
        }, Object.create(null)); */
  
        setShiftList(shiftList);

        console.log('SHift List: ', shiftList)
  
        if (shiftList.length > 0) {
          
          fetchShiftUsers("Shift-Engineers").then((users: any) => {            
            let userNewArray: any = [];
            users.forEach((user: any)=>{
              let _user = user;
              
              let shiftInfo: any = shiftList.filter(o => o.shift.includes(_user.Shift));
              if (shiftInfo.length > 0) {
                _user.ShiftName = shiftInfo[0]['shiftName'];
                _user.DisplayOrder = shiftInfo[0]['displayOrder']
              }

              if (_user.Shift === "General") {
                _user.ShiftName = "General";
                _user.DisplayOrder = 4;
              }
              
              userNewArray.push(_user);
            })

            // console.log('NEW USER LIST: ', userNewArray);

            userNewArray = userNewArray.sort((a, b) => {
              let fa = a.DisplayOrder, fb = b.DisplayOrder;
          
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
      
            userNewArray = userNewArray.reduce(function (r, a) {
              r[a.ShiftName] = r[a.ShiftName] || [];
              r[a.ShiftName].push(a);
              return r;
            }, Object.create(null));
      
            // console.log('USERS 123: ', userNewArray)
      
            setUsers(userNewArray);
            dispatch(getShiftUserList(userNewArray));
          });
        }
      });
    });
  };

  const fetchLogEntries = () => {
    let logTableItems: any = [];
    fetchAllLogs('SK-OnCall-Handover-Logs').then((logs: any) => {
      // console.log('LOGS: ', logs)
      
      logs.map((item: any) => {
        logTableItems.push({
          //'LOG_ID': item.LogID,
          'LOG_DATETIME': item.CreatedAt,
          'HANDOVER_BY': item.HandoverBy,
          //'SHIFT_NAME': item.ShiftName,
          'SHIFT_FROM': item.ShiftFrom,
          'SHIFT_TO': item.Shift,
          'SHIFT_OVERWRITE': item.ShiftOverWrite ? "YES" : "NO",
          'LOG_DETAILS': item.LogDetails,
          'NOTES': item.Notes,
          'TICKETS_LOG': item.TicketsLogs,
          'ALARM_LOG': item.AlarmLogs
        });
      });

      
      logTableItems.sort(function (a, b) {
        const logCreatedAt = new Date(a.LOG_DATETIME);

        const year = logCreatedAt.getFullYear();
        const month = String(logCreatedAt.getMonth() + 1).padStart(2, '0');
        const day = String(logCreatedAt.getDate()).padStart(2, '0');
        const hours = String(logCreatedAt.getHours()).padStart(2, '0');
        const minutes = String(logCreatedAt.getMinutes()).padStart(2, '0');
        const seconds = String(logCreatedAt.getSeconds()).padStart(2, '0');

        const sortDateTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

        console.log(sortDateTime)
        
        let dateA: any = new Date(b.LOG_DATETIME);
        let dateB: any = new Date(a.LOG_DATETIME);
        return dateA - dateB;
      });
      
      setLogTableData(logTableItems);

      setLoading(false);
    });
  };

  const shiftRefreshHandler = () => {
    fetchShiftList();
  };

  const logRefreshHandler = () => {
    fetchLogEntries();
  };

  /* useEffect(() => {
    dispatch(getShiftUserList());
  }, [dispatch]); */

  const logColumns = useMemo<MRT_ColumnDef<Log>[]>(
    () => [
      /* {
        accessorKey: 'LOG_ID',
        header: 'Log Id',
        enableColumnFilter: false,
        size: 150,
      }, */
      {
        accessorKey: 'LOG_DATETIME',
        header: 'Log Time',
        enableColumnFilter: false,
        size: 250
      },
      {
        accessorKey: 'HANDOVER_BY',
        header: 'Handover By',
        enableColumnFilter: false,
        size: 200,
      },
      /* {
        accessorKey: 'SHIFT_NAME',
        header: 'Shift Name',
        enableColumnFilter: false,
        size: 250
      }, */
      /* {
        accessorKey: 'SHIFT_FROM',
        header: 'Shift From',
        enableColumnFilter: false,
        size: 100,
      }, */
      {
        accessorKey: 'SHIFT_TO',
        header: 'Shift',
        enableColumnFilter: false,
        size: 100,
      },
      {
        accessorKey: 'SHIFT_OVERWRITE',
        header: 'Is Shift Overwrite',
        enableColumnFilter: false,
        size: 100,
      },
      {
        accessorKey: 'LOG_DETAILS',
        header: 'Log Details',
        enableColumnFilter: false,
        size: 200
      },
      {
        accessorKey: 'NOTES',
        header: 'Notes',
        enableColumnFilter: false,
        size: 200
      },
      {
        accessorKey: 'TICKETS_LOG',
        header: 'Tickets Log',
        id: 'TICKETS_LOG',
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <IconButton
            onClick={() => {
              setSelectedLogRow(row.original.TICKETS_LOG); // Set selected row data
              setOpenLogDialog(true); // Open dialog
            }}
          >
            <InfoIcon />
          </IconButton>
        ),
      },
      {
        accessorKey: 'ALARM_LOG',
        header: 'Alarms Log',
        id: 'ALARM_LOG',
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <IconButton
            onClick={() => {
              setSelectedLogRow(row.original.ALARM_LOG); // Set selected row data
              setOpenLogDialog(true); // Open dialog
            }}
          >
            <InfoIcon />
          </IconButton>
        ),
      },
    ],
    [],
  );

  const optionsHandoverBtn = ['Handover with call', 'Handover with tickets'];

  const [openHandoverBtn, setOpenHandoverBtn] = React.useState(false);
  const anchorRefHandoverBtn = React.useRef<HTMLDivElement>(null);
  const [selectedIndexHandoverBtn, setSelectedIndexHandoverBtn] = React.useState(0);

  const handleClickHandoverBtn = () => {
    console.info(`You clicked ${optionsHandoverBtn[selectedIndexHandoverBtn]}`);
  };

  const handleMenuItemClickHandoverBtn = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    dispatch(SharedDialogActions.openDialog());
    setSelectedIndexHandoverBtn(index);
    setOpenHandoverBtn(false);
  };

  const handleToggleHandoverBtn = () => {
    setOpenHandoverBtn((prevOpen) => !prevOpen);
  };

  const handleCloseHandoverBtn = (event: Event) => {
    if (
      anchorRefHandoverBtn.current &&
      anchorRefHandoverBtn.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpenHandoverBtn(false);
  };

  useEffect(() => {
    fetchShiftList();
    fetchLogEntries();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      fetchLogEntries();
    }
  }, [data]);

  return (
    <div className="landing">
      <Box style={{
        backgroundColor: "#fff",
        padding: "15px"
      }}>
        <Box sx={{ padding: "15px" }}>
          <Box sx={{ marginBottom: "0px" }}>
            <Grid
              container
              spacing={3}
              justifyContent="flex-start"
              alignItems="stretch"
              >
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}>
                    <Box>
                      <Typography variant="h5"><strong>Shift Details</strong></Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="flex-end">
                      {/* <Button variant="contained" startIcon={<AddIcon />} onClick={() => dispatch(SharedDrawerActions.openDrawer())}>Assign shift</Button>
                      <SharedDrawer children={<div>Test</div>} heading={"Assign shift"} /> */}
                      <Button variant="outlined" startIcon={<RefreshIcon />} onClick={shiftRefreshHandler}>Refresh</Button>
                      {/* <Button className={classes.actionBtn1} variant="contained" sx={{marginLeft: 2}} onClick={() => dispatch(SharedDialogActions.openDialog())}>Handover</Button> */}
                    
                        <ButtonGroup
                          variant="contained"
                          ref={anchorRefHandoverBtn}
                          aria-label="Button group with a nested menu"
                          className={classes.actionBtn1}
                          sx={{marginLeft: 2}}
                        >
                          <Button onClick={handleClickHandoverBtn}>{optionsHandoverBtn[selectedIndexHandoverBtn]}</Button>
                          <Button
                            size="small"
                            aria-controls={openHandoverBtn ? 'split-button-menu' : undefined}
                            aria-expanded={openHandoverBtn ? 'true' : undefined}
                            aria-label="select merge strategy"
                            aria-haspopup="menu"
                            onClick={handleToggleHandoverBtn}
                          >
                            <ArrowDropDownIcon />
                          </Button>
                        </ButtonGroup>
                        <Popper
                          sx={{ zIndex: 1 }}
                          open={openHandoverBtn}
                          anchorEl={anchorRefHandoverBtn.current}
                          role={undefined}
                          transition
                          disablePortal
                          onResize={() => {}} 
                          onResizeCapture={() => {}}
                        >
                          {({ TransitionProps, placement }) => (
                            <Grow
                              {...TransitionProps}
                              style={{
                                transformOrigin:
                                  placement === 'bottom' ? 'center top' : 'center bottom',
                              }}
                            >
                              <Paper>
                                <ClickAwayListener onClickAway={handleCloseHandoverBtn}>
                                  <MenuList id="split-button-menu" autoFocusItem>
                                    {optionsHandoverBtn.map((option, index) => (
                                      <MenuItem
                                        key={option}
                                        disabled={index === 2}
                                        selected={index === selectedIndexHandoverBtn}
                                        onClick={(event) => handleMenuItemClickHandoverBtn(event, index)}
                                      >
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </MenuList>
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {Object.keys(users).map((key, index) => {
                const shiftTiming: any = SHIFT_TIMINGS.filter(o => o.shiftName.includes(key));
                console.log(key);
                return (
                  <Grid item xs={4} key={index}>
                    <Card className={classes.card}>
                    <CardHeader
                        title={
                          <Stack className={classes.cardHeaderTitle} direction="row" spacing={1}>
                            <EventRepeatIcon sx={{width: "0.75em"}} />
                            <Typography className={classes.cardHeaderTitle}>
                             {key}
                            </Typography>
                          </Stack>
                        }
                        subheader={
                          <Stack className={classes.cardSubHeader} direction="row" spacing={1}>
                            <AccessTimeIcon sx={{width: "0.75em"}} />
                            <Typography className={classes.cardSubHeader}>
                              {shiftTiming.length > 0 && shiftTiming[0]['startTime'] !== "" ? `${shiftTiming[0]['startTime'] } to ${shiftTiming[0]['endTime'] }`: "N/A"}
                            </Typography>
                        </Stack>
                        }
                        className={classes.cardHeader}
                      />
                      <Divider/>
                      <CardContent sx={{ textAlign: "left" }}>
                        {/* <Typography variant="h5" color="text.secondary" gutterBottom>
                          {users[key][0]['ShiftName']} {users[key][0]['ShiftStartTime'] + " - " + users[key][0]['ShiftEndTime']}
                        </Typography> */}
                        <ItemsList isHandover={shiftList[index]['isHandover']} shiftEndTime={shiftList[index]['shiftEndTime']} items={users[key]} dispatch={dispatch} />
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box mt={4} sx={{backgroundColor: "#fff", padding: "30px"}}>
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="stretch"
        >
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={6}>
                <Box>
                  <Typography variant="h5"><strong>Shift Logs</strong></Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  {/* <Button variant="contained" startIcon={<AddIcon />} onClick={() => dispatch(SharedDrawerActions.openDrawer())}>Assign shift</Button>
                  <SharedDrawer children={<div>Test</div>} heading={"Assign shift"} /> */}
                  <Button variant="outlined" startIcon={<RefreshIcon />} onClick={logRefreshHandler}>Refresh</Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <MaterialReactTable
              columns={logColumns}
              data={logTableData}
              enableColumnFilterModes
              enableColumnOrdering={false}
              enableGrouping={false}
              enablePinning
              enableColumnActions={false}
              initialState={{
                showColumnFilters: true, // Enables column filters
                pagination: { pageIndex: 0, pageSize: 50 } // Sets pagination options
              }}
              positionToolbarAlertBanner="bottom"
              state={{ isLoading: loading }}
            />
          </Grid>
        </Grid>
        {/* <SharedDialog children={ <HandoverForm handoverType={selectedIndexHandoverBtn} dispatch={dispatch} /> } heading="Shift Handover" /> */}
        <SharedDialog
          heading="Shift Handover"
          children={
            selectedIndexHandoverBtn === 0 ? (
              <HandoverFormWithCall dispatch={dispatch} />
            ) : (
              <HandoverFormWithTickets dispatch={dispatch} />
            )
          }
        />
        <div>
            {/* Dialog for JSON Display */}
            <Dialog open={openLogDialog} onClose={() => setOpenLogDialog(false)}>
              <DialogTitle>Log Details</DialogTitle>
              <DialogContent>
              <ReactJson
                src={selectedLogRow || {}} // JSON data
                theme="monokai" // Choose a theme (other options: "apathy", "ocean", etc.)
                iconStyle="circle" // Icons for collapse/expand
                displayDataTypes={false} // Hide data types
                enableClipboard={true} // Allow copying JSON
                collapsed={false} // Do not collapse by default
              />
              </DialogContent>
            </Dialog>
        </div>
      </Box>
    </div>
  );
}

interface Engineer {
  Name: string;
  Shift: string;
  ShiftName: string;
}

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

function HandoverFormWithCall(props) {
  const classes = useStyles();

  const { displayNotification } = useNotification();
  
  const { dispatch } = props;

  const [openPrimary, setOpenPrimary] = React.useState(false);
  const [optionsPrimary, setOptionsPrimary] = React.useState<readonly Engineer[]>([]);
  const loadingPrimary = false; //openPrimary && optionsPrimary.length === 0;

  const [openSecondary, setOpenSecondary] = React.useState(false);
  const [optionsSecondary, setOptionsSecondary] = React.useState<readonly Engineer[]>([]);
  const loadingSecondary = false; //openSecondary && optionsSecondary.length === 0;

  const [selectedOptionsPrimary, setSelectedOptionsPrimary] = React.useState([]);
  const [selectedOptionsSecondary, setSelectedOptionsSecondary] = React.useState([]);

  const [allUsers, setAllUsers] = React.useState([]);
  const [shiftUsers, setShiftUsers] = React.useState([]);

  const [noteTabsValue, setNoteTabsValue] = React.useState(0);

  const handleNoteTabsChange = (event: React.SyntheticEvent, newValue: number) => {
    setNoteTabsValue(newValue);
  };

  // Initial Table Data
  const [ticketsData, setTicketsData] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false); // Control dialog visibility
  const [selectedRowIndex, setSelectedRowIndex] = useState(null); // Track the index of the selected row
  const [ticketsTicketDataLoading, setTicketsDataLoading] = useState(true); // State for loading indicator

  // Open dialog and set editing row data
  const handleEditClick = (index) => {
    setSelectedRowIndex(index); // Store the index of the row being edited
    setDialogOpen(true); // Open dialog
  };

  // Close dialog
  const handleDialogClose = (index) => {
    setDialogOpen(false);
    setSelectedRowIndex(index); // Store the index of the row being edited
  };

  // Handle form input changes for the dialog
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTicketsData((prev) =>
      prev.map((row, index) =>
        index === selectedRowIndex
          ? { ...row, [name]: value } // Update only the selected row
          : row
      )
    );
  };

  // Define Table Columns
  const ticketsColumns: MRT_ColumnDef<{
    ticketId: number;
    clientName: string;
    status: string;
    createdAt: string;
    duration: string;
    assignedTo: string;
    team: string;
    detail1: string;
    detail2: string;
  }>[] = [
    { accessorKey: 'ticketId', header: 'Ticket ID' }, // Match exact key
    { accessorKey: 'clientName', header: 'Client Name' },
    { accessorKey: 'status', header: 'Status' },
    { accessorKey: 'createdAt', header: 'Created At' },
    { accessorKey: 'duration', header: 'Duration' },
    { accessorKey: 'assignedTo', header: 'Assigned To' },
    { accessorKey: 'team', header: 'Team' },
    // Actions column
    {
      id: 'actions', // Explicitly set 'id' for non-data columns
      header: 'Actions',
      Cell: ({ row }) => (
        <Button variant="outlined" onClick={() => handleEditClick(row.index)}>
          Edit
        </Button>
      ),
    },
  ];


  // Alarms data
  // Initial Table Data
  const [alarmsData, setAlarmData] = useState([]);

  const [dialogAlarmDataOpen, setDialogAlarmDataOpen] = useState(false); // Control dialog visibility
  const [selectedRowIndexAlarmData, setSelectedRowIndexAlarmData] = useState(null); // Track the index of the selected row
  const [alarmDataLoading, setAlarmDataLoading] = useState(true); // State for loading indicator

  // Open dialog and set editing row data
  const handleEditClickAlarmData = (index) => {
    setSelectedRowIndexAlarmData(index);
    setDialogAlarmDataOpen(true); // Open dialog
  };

  // Close dialog
  const handleDialogCloseAlarmData = (index) => {
    setDialogAlarmDataOpen(false);
    setSelectedRowIndexAlarmData(index);
  };

  // Handle form input changes for the dialog
  const handleInputChangeAlarmData = (e) => {
    const { name, value } = e.target;
    setAlarmData((prev) =>
      prev.map((row, index) =>
        index === selectedRowIndexAlarmData
          ? { ...row, [name]: value } // Update only the selected row
          : row
      )
    );
  };

  // Define Table Columns
  const alarmsColumns: MRT_ColumnDef<{
    id: string;
    client: string;
    alert: string;
    creationTime: string;
    assigned: string[];
    detail1: string;
    detail2: string;
  }>[] = [
    { accessorKey: 'id', header: 'Alarm ID' }, // Match exact key
    { accessorKey: 'client', header: 'Client Name' },
    { accessorKey: 'alert', header: 'Alert' },
    { accessorKey: 'creationTime', header: 'Creation Time' },
    { accessorKey: 'assigned', header: 'Assigned', Cell: ({ row }) => row.original.assigned.join(', ') },
  
    // Actions column
    {
      id: 'actions', // Explicitly set 'id' for non-data columns
      header: 'Actions',
      Cell: ({ row }) => (
        <Button variant="outlined" onClick={() => handleEditClickAlarmData(row.index)}>
          Edit
        </Button>
      ),
    },
  ];

  const [notesTab, setNotesTab] = useState("");

  // Fetch Data from Backend
  useEffect(() => {
    const fetchTicketsData = async () => {
      try {
        const response = await axios.get(
          'https://fknzn3uglvgmqkodvauyhn5tqq0zqzph.lambda-url.ap-south-1.on.aws/'
        );
        const formattedData = response.data.map((item) => ({
          ticketId: item[0],
          clientName: item[1],
          status: item[2],
          createdAt: item[3],
          duration: item[4],
          assignedTo: item[5] || 'Unassigned', // Handle null values
          team: item[6] || 'Unknown', // Handle null values
          detail1: '',
          detail2: '',
        }));
        setTicketsData(formattedData); // Update state with formatted data
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setTicketsDataLoading(false); // Set loading to false after fetch
      }
    };

    fetchTicketsData();

    const fetchAlarmsData = async () => {
      try {
        const response = await axios.get(
          'https://zpg7m5v7bwvfwjld6lan6optxy0unuio.lambda-url.ap-south-1.on.aws/'
        );
        const formattedData = response.data.map((item) => ({
          id: item.id,
          severity: item.severity,
          client: item.client,
          alert: item.alert,
          creationTime: item.creationTime,
          assigned: item.assinged,
          detail1: '',
          detail2: '',
        }));
        setAlarmData(formattedData); // Update state with formatted data

        console.log('Alarms Data: ', formattedData)
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setAlarmDataLoading(false); // Set loading to false after fetch
      }
    };

    fetchAlarmsData();
  }, []); // Empty dependency array ensures fetch runs only once


  const [profile, setProfile] = useState<any>({});

  const [shift, setShift] = React.useState<string>('');
  const [open, setOpen] = React.useState(false);

  const [shiftOverWrite, setShiftOverWrite] = React.useState(false);
  const [disableSubmitAction, setDisableSubmitAction] = React.useState(false);

  const CHARACTER_LIMIT = 1000;

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangePrimary = (event: any, value: any) => {
    setSelectedOptionsPrimary(value);
  };

  const handleChangeSecondary = (event: any, value: any) => {
    setSelectedOptionsSecondary(value);
  };

  const handleShiftChange = (event: SelectChangeEvent<typeof shift>) => {
    setShift(event.target.value);
    updateUserListBasedOnShiftName(shiftUsers, event.target.value, shiftOverWrite)
    
    if (!shiftOverWrite) {
      setDisableSubmitAction(checkHandoverStatus(event.target.value));

      setSelectedOptionsPrimary([]);
      setSelectedOptionsSecondary([]);
    }
  };

  const handleChangeShiftOverwrite = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShiftOverWrite(event.target.checked);
    
    if (event.target.checked)
      setDisableSubmitAction(false);
    else 
      setDisableSubmitAction(checkHandoverStatus(shift));

    if (event.target.checked) {
      setOptionsPrimary(allUsers);
      setOptionsSecondary(allUsers);
    }
    else {
      if (shift) {
        updateUserListBasedOnShiftName(shiftUsers, shift, event.target.checked);

        setSelectedOptionsPrimary([]);
        setSelectedOptionsSecondary([]);
      }
      else {
        setOptionsPrimary([]);
        setOptionsSecondary([]);
      }
    }
  };

  const updateUserListBasedOnShiftName = (userList: any, shiftName: string = "", shiftOverWrite: boolean = false) => {
    if (shiftName) {
      let filteredUserList: any = [];
      if (!shiftOverWrite && userList[shiftName] !== undefined) {
        filteredUserList = userList[shiftName];
      }
      else {
        filteredUserList = allUsers;
      }
      
      setOptionsPrimary(filteredUserList);
      setOptionsSecondary(filteredUserList);
    }
    else {
      setOptionsPrimary([]);
      setOptionsSecondary([]);
    }
  };

  const checkHandoverStatus = (shiftName: string) => {
    const shiftDetails: any = SHIFT_TIMINGS.filter(o => o.shiftName.includes(shiftName));
    const shiftStartTime = shiftDetails[0].startTime;
    
    // Get the current date
    const currentDate = new Date();

    // Get year, month, and day components
    const year = currentDate.getFullYear();
    // Months are 0-indexed, so add 1 to get the correct month
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Form the "yyyy-mm-dd" date string
    const formattedDate = `${year}-${month}-${day}`;

    const shiftTime = changeTimeZone(`${formattedDate} ${shiftStartTime}`);

    // console.log('Shift DATE: ', shiftTime)

    let disableSubmitAction: boolean = true;

    if (shiftStartTime && isShiftOverdue(shiftTime)) {
      console.log("Please handover");
      disableSubmitAction = false;
    }

    return disableSubmitAction;
  };

  const onSubmitHandover = async () => {
    const shiftDetails: any = optionsPrimary.filter(o => o.ShiftName.includes(shift));
    
    const dateTimeISOFormat = new Date()
    const date = changeTimeZone(dateTimeISOFormat);

    // Extract year, month, day, hours, minutes, and seconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(1, '0');
    const day = String(date.getDate()).padStart(1, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Create the formatted date and time string
    const formattedDate = `${day}/${month}/${year}`;
    const formattedDateTime = `${formattedDate} ${hours}:${minutes}:${seconds}`;

    const currentDayLogs: any = await queryTableItems('SK-OnCall-Handover-Logs', formattedDate);
    
    let userShiftLogInfo: any = [];
    if (!shiftOverWrite && currentDayLogs.length > 0 ) userShiftLogInfo = currentDayLogs.filter(o => o.Shift.includes(shift));
      let logDetails: any = {};
      logDetails.HANDOVER_BY = profile.email;

      console.log('Log Details: ', JSON.stringify(logDetails));

      queryTableItems('Shift-Engineers', profile.email).then(async (userItems: any) => {
          const logItem = {
            PK: `LOG#${formattedDate}`, // Partition Key - Primary Identifier
            SK: `SHIFT#${shift}#${formattedDateTime}`, // Sort Key - Enables querying by shift and timestamp
            CreatedAt: formattedDateTime, // ISO 8601 format for date-time
            Shift: shift, // Current shift name (String)
            ShiftOverWrite: shiftOverWrite, // Overwritten shift name (String)
            HandoverBy: profile.name, // Engineer who performed the handover (String)
            LogDetails: JSON.stringify(logDetails),
            TicketsLogs: ticketsData.map(ticket => ({ // Store tickets as an array of objects
              ticketId: ticket.ticketId,
              clientName: ticket.clientName,
              status: ticket.status,
              createdAt: ticket.createdAt,
              duration: ticket.duration,
              assignedTo: ticket.assignedTo || 'Unassigned',
              team: ticket.team || 'Unknown',
              whatWasDone: ticket.detail1 || '',
              whatNext: ticket.detail2 || '',
            })),
            AlarmLogs: alarmsData.map(item => ({ // Store alarm as an array of objects
              id: item.id,
              severity: item.severity,
              client: item.client,
              alert: item.alert,
              creationTime: item.creationTime,
              assigned: item.assinged,
              //team: item.team || 'Unknown',
              whatWasDone: item.detail1 || '',
              whatNext: item.detail2 || '',
            })),
            Notes: notesTab,
          };

          await createLogItem('SK-OnCall-Handover-Logs', logItem);
          displayNotification({
            // message: `The ${selectedOptionsPrimary[0]['ShiftName']} shift has been successfully submitted.`,
            message: `The details for the ${shift} shift have been created in the database.`,
            type: "success"
          });
          
          dispatch(getShiftLogList(["refresh"]));
          dispatch(SharedDialogActions.closeDialog());
      }); 
  };

  const initLoading = (data: any) => {
    // Get the current date
    const currentDate = new Date();

    // Get year, month, and day components
    const year = currentDate.getFullYear();
    // Months are 0-indexed, so add 1 to get the correct month
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Form the "yyyy-mm-dd" date string
    const formattedDate = `${year}-${month}-${day}`;

    let matchShiftName = "";
    SHIFT_TIMINGS.map((shift) => {
      if (shift.startTime) {
        const shiftEndTime = changeTimeZone(`${formattedDate} ${shift.startTime}`);
        if (isShiftOverdue(shiftEndTime)) {
          matchShiftName = shift.shiftName;
        }
      }
    });

    // console.log('Match SHift Name: ', matchShiftName);
    
    if (matchShiftName) {
      setShift(matchShiftName);
      updateUserListBasedOnShiftName(data, matchShiftName);
      setDisableSubmitAction(false);
    }
  }

  const onClickClear = () => {
    setShift("");
    setShiftOverWrite(false);
    setSelectedOptionsPrimary([]);
    setSelectedOptionsSecondary([]);
    //setNotes("");
  };

  const { data, isLoading, error } = useAppSelector((state: RootState) => state.shift.userList);

  React.useEffect(() => {
    let active = true;

    let allUsers: any = [];
    Object.keys(data).map((key) => {
      data[key].forEach((user: any)=>{
        //let userShiftInfo: any = data[key].filter(o => o.ShiftName.includes('Week -'));
        //if (userShiftInfo.length === 0)
        allUsers.push(user)
      });
    });

    setAllUsers(allUsers);
    setShiftUsers(data);

    initLoading(data);

    /* if (!loadingPrimary) {
      return undefined;
    } */

    /* (async () => {
      await sleep(1e3); // For demo purposes.

      if (active) {
        setOptionsPrimary([...topFilms]);
        setOptionsSecondary([...topFilms]);
      }
    })(); */

    fetchShiftUsers("Shift-Engineers").then((users: any) => {
      users = users.sort((a, b) => {
        let fa = a.Shift, fb = b.Shift;
    
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
      });

      // setOptionsPrimary([...users]);
      // setOptionsSecondary([...users]);

      // setAllUsers(users);
    });

    /* return () => {
      active = false;
    }; */
  }, []);

  /* React.useEffect(() => {
    if (!open) {
      setOptionsPrimary([]);
    }
  }, [open]); */

  React.useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setProfile(foundUser);
    }
  },
  []);

  return (
    <Box sx={{ width: 780 }}>
      <Box sx={{ width: '100%', marginTop: "25px" }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={noteTabsValue} onChange={handleNoteTabsChange}>
            <Tab label="Tickets" {...a11yProps(0)} />
            <Tab label="Alerts" {...a11yProps(1)} />
            <Tab label="Notes" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={noteTabsValue} index={0}>
          <div>
            <MaterialReactTable columns={ticketsColumns} data={ticketsData} initialState={{ pagination: { pageIndex: 0, pageSize: 30 } }}
            // Disable Search, Filters, and Expand Features
            enableGlobalFilter={false} // Disable global search
            enableColumnFilters={false} // Disable column filters
            enableSorting={false} // Disable sorting
            enablePagination={true} // Disable pagination
            enableRowSelection={false} // Disable row selection
            enableExpanding={false} // Disable expand/collapse rows
            />
            
            {/* Dialog for Editing Rows */}
            <Dialog open={dialogOpen} onClose={handleDialogClose}>
              <DialogTitle>Ticket: Update Work Summary</DialogTitle>
              <DialogContent>
                <TextField
                  label="What was done"
                  name="detail1"
                  value={ticketsData[selectedRowIndex]?.detail1 || ''}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <TextField
                  label="What next"
                  name="detail2"
                  value={ticketsData[selectedRowIndex]?.detail2 || ''}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <Button onClick={handleDialogClose} color="primary" variant="contained" style={{ marginTop: '16px' }}>
                  Close
                </Button>
              </DialogContent>
            </Dialog>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={noteTabsValue} index={1}>
        <div>
            <MaterialReactTable columns={alarmsColumns} data={alarmsData} initialState={{ pagination: { pageIndex: 0, pageSize: 30 } }}
            // Disable Search, Filters, and Expand Features
            enableGlobalFilter={false} // Disable global search
            enableColumnFilters={false} // Disable column filters
            enableSorting={false} // Disable sorting
            enablePagination={true} // Disable pagination
            enableRowSelection={false} // Disable row selection
            enableExpanding={false} // Disable expand/collapse rows
            />
            
            {/* Dialog for Editing Rows */}
            <Dialog open={dialogAlarmDataOpen} onClose={handleDialogCloseAlarmData}>
              <DialogTitle>Alarm: Update Work Summary</DialogTitle>
              <DialogContent>
                <TextField
                  label="What was done"
                  name="detail1"
                  value={alarmsData[selectedRowIndexAlarmData]?.detail1 || ''}
                  onChange={handleInputChangeAlarmData}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <TextField
                  label="What next"
                  name="detail2"
                  value={alarmsData[selectedRowIndexAlarmData]?.detail2 || ''}
                  onChange={handleInputChangeAlarmData}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <Button onClick={handleDialogCloseAlarmData} color="primary" variant="contained" style={{ marginTop: '16px' }}>
                  Close
                </Button>
              </DialogContent>
            </Dialog>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={noteTabsValue} index={2}>
          <Box>
            <TextField
              fullWidth
              label="Notes"
              inputProps={{
                maxLength: CHARACTER_LIMIT
              }}
              id="notes"
              value={notesTab}
              multiline
              rows={4}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNotesTab(event.target.value);
              }}
            helperText={`${notesTab.length}/${CHARACTER_LIMIT}`} />
          </Box>
        </CustomTabPanel>
      </Box>

      <Box>
        <Button fullWidth className={classes.actionBtn1} sx={{marginTop: "30px", marginBottom: "15px"}} variant="contained" disabled={disableSubmitAction} onClick={onSubmitHandover}>Submit</Button>
        <Button fullWidth variant="outlined" onClick={onClickClear}>Clear</Button>
      </Box>
    </Box>
  );
}

function HandoverFormWithTickets(props) {
  const classes = useStyles();

  const { displayNotification } = useNotification();
  
  const { dispatch } = props;

  const [openPrimary, setOpenPrimary] = React.useState(false);
  const [optionsPrimary, setOptionsPrimary] = React.useState<readonly Engineer[]>([]);
  const loadingPrimary = false; //openPrimary && optionsPrimary.length === 0;

  const [openSecondary, setOpenSecondary] = React.useState(false);
  const [optionsSecondary, setOptionsSecondary] = React.useState<readonly Engineer[]>([]);
  const loadingSecondary = false; //openSecondary && optionsSecondary.length === 0;

  const [selectedOptionsPrimary, setSelectedOptionsPrimary] = React.useState([]);
  const [selectedOptionsSecondary, setSelectedOptionsSecondary] = React.useState([]);

  const [allUsers, setAllUsers] = React.useState([]);
  const [shiftUsers, setShiftUsers] = React.useState([]);

  //const [notes, setNotes] = React.useState("");

  const [noteTabsValue, setNoteTabsValue] = React.useState(0);

  const handleNoteTabsChange = (event: React.SyntheticEvent, newValue: number) => {
    setNoteTabsValue(newValue);
  };

  // Initial Table Data
  const [ticketsData, setTicketsData] = useState([/*
    { ticketId: 14441, clientName: 'Mindeed', status: 'Customer Action Required', createdAt: '2024-12-25T09:52:35Z', duration: '0 days 15 hours 2 minutes', assignedTo: 'vijayalakshmi.v@shellkode.com', team: 'Atlas', detail1: 'Sample details 1', detail2: 'Sample details 2' },
    { ticketId: 14437, clientName: 'Paynearby', status: 'Customer Action Required', createdAt: '2024-12-25T09:52:35Z', duration: '1 days 9 hours 34 minutes', assignedTo: 'karthik.b@shellkode.com', team: 'Cronos', detail1: 'Sample details 1', detail2: 'Sample details 2' },
    { ticketId: 14425, clientName: 'Paynearby', status: 'Customer Action Required', createdAt: '2024-12-25T09:52:35Z', duration: '1 days 18 hours 48 minutes', assignedTo: 'rithik.s@shellkode.com', team: 'Cronos', detail1: 'Sample details 1', detail2: 'Sample details 2' }, */
  ]);

  const [dialogOpen, setDialogOpen] = useState(false); // Control dialog visibility
  const [selectedRowIndex, setSelectedRowIndex] = useState(null); // Track the index of the selected row
  const [ticketsTicketDataLoading, setTicketsDataLoading] = useState(true); // State for loading indicator

  // Open dialog and set editing row data
  const handleEditClick = (index) => {
    setSelectedRowIndex(index); // Store the index of the row being edited
    setDialogOpen(true); // Open dialog
  };

  // Close dialog
  const handleDialogClose = (index) => {
    setDialogOpen(false);
    setSelectedRowIndex(index); // Store the index of the row being edited
  };

  // Handle form input changes for the dialog
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTicketsData((prev) =>
      prev.map((row, index) =>
        index === selectedRowIndex
          ? { ...row, [name]: value } // Update only the selected row
          : row
      )
    );
  };

  // Define Table Columns
  const ticketsColumns: MRT_ColumnDef<{
    ticketId: number;
    clientName: string;
    status: string;
    createdAt: string;
    duration: string;
    assignedTo: string;
    team: string;
    detail1: string;
    detail2: string;
  }>[] = [
    { accessorKey: 'ticketId', header: 'Ticket ID' }, // Match exact key
    { accessorKey: 'clientName', header: 'Client Name' },
    { accessorKey: 'status', header: 'Status' },
    { accessorKey: 'createdAt', header: 'Created At' },
    { accessorKey: 'duration', header: 'Duration' },
    { accessorKey: 'assignedTo', header: 'Assigned To' },
    { accessorKey: 'team', header: 'Team' },
    //{ accessorKey: 'detail1', header: 'Detail 1' },
    //{ accessorKey: 'detail2', header: 'Detail 2' },
  
    // Actions column
    {
      id: 'actions', // Explicitly set 'id' for non-data columns
      header: 'Actions',
      Cell: ({ row }) => (
        <Button variant="outlined" onClick={() => handleEditClick(row.index)}>
          Edit
        </Button>
      ),
    },
  ];


  // Alarms data
  // Initial Table Data
  const [alarmsData, setAlarmData] = useState([]);

  const [dialogAlarmDataOpen, setDialogAlarmDataOpen] = useState(false); // Control dialog visibility
  const [selectedRowIndexAlarmData, setSelectedRowIndexAlarmData] = useState(null); // Track the index of the selected row
  const [alarmDataLoading, setAlarmDataLoading] = useState(true); // State for loading indicator

  // Open dialog and set editing row data
  const handleEditClickAlarmData = (index) => {
    setSelectedRowIndexAlarmData(index);
    setDialogAlarmDataOpen(true); // Open dialog
  };

  // Close dialog
  const handleDialogCloseAlarmData = (index) => {
    setDialogAlarmDataOpen(false);
    setSelectedRowIndexAlarmData(index);
  };

  // Handle form input changes for the dialog
  const handleInputChangeAlarmData = (e) => {
    const { name, value } = e.target;
    setAlarmData((prev) =>
      prev.map((row, index) =>
        index === selectedRowIndexAlarmData
          ? { ...row, [name]: value } // Update only the selected row
          : row
      )
    );
  };

  // Define Table Columns
  const alarmsColumns: MRT_ColumnDef<{
    id: string;
    client: string;
    alert: string;
    creationTime: string;
    assigned: string[];
    detail1: string;
    detail2: string;
  }>[] = [
    { accessorKey: 'id', header: 'Alarm ID' }, // Match exact key
    { accessorKey: 'client', header: 'Client Name' },
    { accessorKey: 'alert', header: 'Alert' },
    { accessorKey: 'creationTime', header: 'Creation Time' },
    { accessorKey: 'assigned', header: 'Assigned', Cell: ({ row }) => row.original.assigned.join(', ') },
  
    // Actions column
    {
      id: 'actions', // Explicitly set 'id' for non-data columns
      header: 'Actions',
      Cell: ({ row }) => (
        <Button variant="outlined" onClick={() => handleEditClickAlarmData(row.index)}>
          Edit
        </Button>
      ),
    },
  ];

  const [notesTab, setNotesTab] = useState("");

  // Fetch Data from Backend
  useEffect(() => {
    const fetchTicketsData = async () => {
      try {
        const response = await axios.get(
          'https://fknzn3uglvgmqkodvauyhn5tqq0zqzph.lambda-url.ap-south-1.on.aws/'
        );
        const formattedData = response.data.map((item) => ({
          ticketId: item[0],
          clientName: item[1],
          status: item[2],
          createdAt: item[3],
          duration: item[4],
          assignedTo: item[5] || 'Unassigned', // Handle null values
          team: item[6] || 'Unknown', // Handle null values
          detail1: '',
          detail2: '',
        }));
        setTicketsData(formattedData); // Update state with formatted data
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setTicketsDataLoading(false); // Set loading to false after fetch
      }
    };

    fetchTicketsData();

    const fetchAlarmsData = async () => {
      try {
        const response = await axios.get(
          'https://zpg7m5v7bwvfwjld6lan6optxy0unuio.lambda-url.ap-south-1.on.aws/'
        );
        const formattedData = response.data.map((item) => ({
          id: item.id,
          severity: item.severity,
          client: item.client,
          alert: item.alert,
          creationTime: item.creationTime,
          assigned: item.assinged,
          detail1: '',
          detail2: '',
        }));
        setAlarmData(formattedData); // Update state with formatted data

        console.log('Alarms Data: ', formattedData)
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setAlarmDataLoading(false); // Set loading to false after fetch
      }
    };

    fetchAlarmsData();
  }, []); // Empty dependency array ensures fetch runs only once


  const [profile, setProfile] = useState<any>({});

  const [shift, setShift] = React.useState<string>('');
  const [open, setOpen] = React.useState(false);

  const [shiftOverWrite, setShiftOverWrite] = React.useState(false);
  const [disableSubmitAction, setDisableSubmitAction] = React.useState(true);

  const CHARACTER_LIMIT = 1000;

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangePrimary = (event: any, value: any) => {
    setSelectedOptionsPrimary(value);
  };

  const handleChangeSecondary = (event: any, value: any) => {
    setSelectedOptionsSecondary(value);
  };

  const handleShiftChange = (event: SelectChangeEvent<typeof shift>) => {
    setShift(event.target.value);
    updateUserListBasedOnShiftName(shiftUsers, event.target.value, shiftOverWrite)
    
    if (!shiftOverWrite) {
      setDisableSubmitAction(checkHandoverStatus(event.target.value));

      setSelectedOptionsPrimary([]);
      setSelectedOptionsSecondary([]);
    }
  };

  const handleChangeShiftOverwrite = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShiftOverWrite(event.target.checked);
    
    if (event.target.checked)
      setDisableSubmitAction(false);
    else 
      setDisableSubmitAction(checkHandoverStatus(shift));

    if (event.target.checked) {
      setOptionsPrimary(allUsers);
      setOptionsSecondary(allUsers);
    }
    else {
      if (shift) {
        updateUserListBasedOnShiftName(shiftUsers, shift, event.target.checked);

        setSelectedOptionsPrimary([]);
        setSelectedOptionsSecondary([]);
      }
      else {
        setOptionsPrimary([]);
        setOptionsSecondary([]);
      }
    }
  };

  const updateUserListBasedOnShiftName = (userList: any, shiftName: string = "", shiftOverWrite: boolean = false) => {
    if (shiftName) {
      let filteredUserList: any = [];
      if (!shiftOverWrite && userList[shiftName] !== undefined) {
        filteredUserList = userList[shiftName];
      }
      else {
        filteredUserList = allUsers;
      }
      
      setOptionsPrimary(filteredUserList);
      setOptionsSecondary(filteredUserList);
    }
    else {
      setOptionsPrimary([]);
      setOptionsSecondary([]);
    }
  };

  const checkHandoverStatus = (shiftName: string) => {
    const shiftDetails: any = SHIFT_TIMINGS.filter(o => o.shiftName.includes(shiftName));
    const shiftStartTime = shiftDetails[0].startTime;
    
    // Get the current date
    const currentDate = new Date();

    // Get year, month, and day components
    const year = currentDate.getFullYear();
    // Months are 0-indexed, so add 1 to get the correct month
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Form the "yyyy-mm-dd" date string
    const formattedDate = `${year}-${month}-${day}`;

    const shiftTime = changeTimeZone(`${formattedDate} ${shiftStartTime}`);

    // console.log('Shift DATE: ', shiftTime)

    let disableSubmitAction: boolean = true;

    if (shiftStartTime && isShiftOverdue(shiftTime)) {
      console.log("Please handover");
      disableSubmitAction = false;
    }

    return disableSubmitAction;
  };

  const onSubmitHandover = async () => {
    const shiftDetails: any = optionsPrimary.filter(o => o.ShiftName.includes(shift));
    
    let errorMessage = "";
    if (shift === "") {
      errorMessage = "Please select a Shift"
    }
    else if (selectedOptionsPrimary.length === 0) {
      errorMessage = "Please select the Primary engineer"
    }
    /* else if (shiftDetails.length > 1 && selectedOptionsSecondary.length === 0) {
      errorMessage = "Please select the Secondary engineer"
    } */

    if (errorMessage !== "") {
      displayNotification({
        message: errorMessage,
        type: "error"
      });
      return
    }
    
    const dateTimeISOFormat = new Date()
    const date = changeTimeZone(dateTimeISOFormat);

    // Extract year, month, day, hours, minutes, and seconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(1, '0');
    const day = String(date.getDate()).padStart(1, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Create the formatted date and time string
    const formattedDate = `${day}/${month}/${year}`;
    const formattedDateTime = `${formattedDate} ${hours}:${minutes}:${seconds}`;

    const currentDayLogs: any = await queryTableItems('SK-OnCall-Handover-Logs', formattedDate);
    // console.log('LOG QUERY ITEM: ', currentDayLogs, shift);
    
    let userShiftLogInfo: any = [];
    if (!shiftOverWrite && currentDayLogs.length > 0 ) userShiftLogInfo = currentDayLogs.filter(o => o.Shift.includes(shift));
    
    if (userShiftLogInfo.length > 0 && userShiftLogInfo[0]['Shift'] === shift) {
      displayNotification({
        message: `The ${userShiftLogInfo[0].Shift} shift has already been submitted by ${userShiftLogInfo[0].HandoverBy}.`,
        type: "error"
      });
    }
    else {
      let logDetails: any = {};
      logDetails.HANDOVER_BY = profile.email;
      logDetails.PRIMARY_CONTACT = [];
      const emailOfPrimaryContact = selectedOptionsPrimary.map((item) => {
        return item.Email
      });

      logDetails.PRIMARY_CONTACT = emailOfPrimaryContact;

      logDetails.SECONDARY_CONTACT = [];
      const emailOfSecondaryContact = selectedOptionsSecondary.map((item) => {
        return item.Email
      });

      logDetails.SECONDARY_CONTACT = emailOfSecondaryContact;

      console.log('Log Details: ', JSON.stringify(logDetails));

      queryTableItems('Shift-Engineers', profile.email).then(async (userItems: any) => {
        // Send to the data to the SSM incident manager - lambda
        // const result = await handoverDataToSSMIncidentManager({ "shiftSequence": "A", "primaryEngineers": selectedOptionsPrimary,  "secondaryEngineers": selectedOptionsSecondary})
        // const result = await handoverDataToSSMIncidentManager({ "PRIMARY_CONTACT": emailOfPrimaryContact,  "SECONDARY_CONTACT": emailOfSecondaryContact});
        const result = '' //await handoverDataToSSMIncidentManager(logDetails);
        //console.log('SUBMITTED: ', result);

        if (result == undefined) {
          displayNotification({
            message: "Oops! Something went wrong.",
            type: "error"
          });
        }
        else {
          // Create a log entry
          /* const logItem = {
            DATE: formattedDate,
            CreatedAt: formattedDateTime,
            Shift: shift,
            // ShiftFrom: userItems[0]['Shift'],
            ShiftOverWrite: shiftOverWrite,
            HandoverBy: profile.name,
            LogDetails: JSON.stringify(logDetails),
            Notes: '',
            TicketsLogs: ''
          }; */

          const logItem = {
            PK: `LOG#${formattedDate}`, // Partition Key - Primary Identifier
            SK: `SHIFT#${shift}#${formattedDateTime}`, // Sort Key - Enables querying by shift and timestamp
            CreatedAt: formattedDateTime, // ISO 8601 format for date-time
            Shift: shift, // Current shift name (String)
            ShiftOverWrite: shiftOverWrite, // Overwritten shift name (String)
            HandoverBy: profile.name, // Engineer who performed the handover (String)
            LogDetails: JSON.stringify(logDetails),
            TicketsLogs: ticketsData.map(ticket => ({ // Store tickets as an array of objects
              ticketId: ticket.ticketId,
              clientName: ticket.clientName,
              status: ticket.status,
              createdAt: ticket.createdAt,
              duration: ticket.duration,
              assignedTo: ticket.assignedTo || 'Unassigned',
              team: ticket.team || 'Unknown',
              whatWasDone: ticket.detail1 || '',
              whatNext: ticket.detail2 || '',
            })),
            AlarmLogs: alarmsData.map(item => ({ // Store alarm as an array of objects
              id: item.id,
              severity: item.severity,
              client: item.client,
              alert: item.alert,
              creationTime: item.creationTime,
              assigned: item.assinged,
              //team: item.team || 'Unknown',
              whatWasDone: item.detail1 || '',
              whatNext: item.detail2 || '',
            })),
            Notes: notesTab,
          };

          await createLogItem('SK-OnCall-Handover-Logs', logItem);
          displayNotification({
            // message: `The ${selectedOptionsPrimary[0]['ShiftName']} shift has been successfully submitted.`,
            message: `The details for the ${shift} shift have been created in the database.`,
            type: "success"
          });

          const result = await handoverDataToSSMIncidentManager(logDetails);
          console.log('CALLED SSM API: ', result);
          if (result == undefined) {
            displayNotification({
              message: "Oops! Something went wrong for SSM API.",
              type: "error"
            });
          }
          
          dispatch(getShiftLogList(["refresh"]));
        
          dispatch(SharedDialogActions.closeDialog());
          
          /* displayNotification({
            // message: `The ${selectedOptionsPrimary[0]['ShiftName']} shift has been successfully submitted.`,
            message: `The ${shift} shift has been successfully submitted.`,
            type: "success"
          }); */
        }
      });
    }    
  };

  const initLoading = (data: any) => {
    // Get the current date
    const currentDate = new Date();

    // Get year, month, and day components
    const year = currentDate.getFullYear();
    // Months are 0-indexed, so add 1 to get the correct month
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Form the "yyyy-mm-dd" date string
    const formattedDate = `${year}-${month}-${day}`;

    let matchShiftName = "";
    SHIFT_TIMINGS.map((shift) => {
      if (shift.startTime) {
        const shiftEndTime = changeTimeZone(`${formattedDate} ${shift.startTime}`);
        if (isShiftOverdue(shiftEndTime)) {
          matchShiftName = shift.shiftName;
        }
      }
    });

    // console.log('Match SHift Name: ', matchShiftName);
    
    if (matchShiftName) {
      setShift(matchShiftName);
      updateUserListBasedOnShiftName(data, matchShiftName);
      setDisableSubmitAction(false);
    }
  }

  const onClickClear = () => {
    setShift("");
    setShiftOverWrite(false);
    setSelectedOptionsPrimary([]);
    setSelectedOptionsSecondary([]);
    //setNotes("");
  };

  const { data, isLoading, error } = useAppSelector((state: RootState) => state.shift.userList);

  React.useEffect(() => {
    let active = true;

    let allUsers: any = [];
    Object.keys(data).map((key) => {
      data[key].forEach((user: any)=>{
        //let userShiftInfo: any = data[key].filter(o => o.ShiftName.includes('Week -'));
        //if (userShiftInfo.length === 0)
        allUsers.push(user)
      });
    });

    setAllUsers(allUsers);
    setShiftUsers(data);

    initLoading(data);

    /* if (!loadingPrimary) {
      return undefined;
    } */

    /* (async () => {
      await sleep(1e3); // For demo purposes.

      if (active) {
        setOptionsPrimary([...topFilms]);
        setOptionsSecondary([...topFilms]);
      }
    })(); */

    fetchShiftUsers("Shift-Engineers").then((users: any) => {
      users = users.sort((a, b) => {
        let fa = a.Shift, fb = b.Shift;
    
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
      });

      // setOptionsPrimary([...users]);
      // setOptionsSecondary([...users]);

      // setAllUsers(users);
    });

    /* return () => {
      active = false;
    }; */
  }, []);

  /* React.useEffect(() => {
    if (!open) {
      setOptionsPrimary([]);
    }
  }, [open]); */

  React.useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setProfile(foundUser);
    }
  },
  []);

  return (
    <Box sx={{ width: 780 }}>
      <FormControl fullWidth sx={{ marginBottom: "25px", marginTop: "10px"}} required>
        <InputLabel id="demo-controlled-open-select-label">Select shift</InputLabel>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={shift}
          label="Select shift"
          onChange={handleShiftChange}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {SHIFT_TIMINGS.map((item, index) => {
            if (item.visibility) {
              return(
                <MenuItem key={index} value={item.shiftName}>{item.shiftName}</MenuItem>
              )}
            }
          )}
        </Select>
      </FormControl>

      <FormGroup sx={{ marginBottom: "25px"}}>
        <FormControlLabel control={<Switch checked={shiftOverWrite} onChange={handleChangeShiftOverwrite} />} label="Shift Overwrite" />
      </FormGroup>

      <Autocomplete
        id="primary-engineer-selection"
        multiple
        open={openPrimary}
        onOpen={() => {
          setOpenPrimary(true);
        }}
        onClose={() => {
          setOpenPrimary(false);
        }}
        value={selectedOptionsPrimary}
        isOptionEqualToValue={(option, value) => option.Name === value.Name}
        groupBy={(option: any) => option.ShiftName}
        getOptionLabel={(option: any) => option.Name}
        limitTags={2}
        options={optionsPrimary}
        getOptionDisabled={(option) => 
          option === selectedOptionsSecondary.find((user) => user.Email == option.Email)
        }
        disableCloseOnSelect
        // loading={false}
        onChange={handleChangePrimary}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {`${option.Name}`} &nbsp;
            <Typography
              sx={{ display: 'inline', color: 'grey' }}
              component="span"
              variant="body2"
              color="text.primary">
              {option.Email}
            </Typography>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Primary Engineer(s)"
            required
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingPrimary ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />

      <Autocomplete
        id="secondary-engineer-selection"
        multiple
        sx={{ marginTop: "25px" }}
        open={openSecondary}
        onOpen={() => {
          setOpenSecondary(true);
        }}
        onClose={() => {
          setOpenSecondary(false);
        }}
        value={selectedOptionsSecondary}
        isOptionEqualToValue={(option, value) => option.Name === value.Name}
        groupBy={(option: any) => option.ShiftName}
        getOptionLabel={(option: any) => option.Name}
        limitTags={2}
        options={optionsSecondary}
        getOptionDisabled={(option) => 
          option === selectedOptionsPrimary.find((user) => user.Email == option.Email)
        }
        disableCloseOnSelect
        // loading={loadingSecondary}
        onChange={handleChangeSecondary}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {`${option.Name}`} &nbsp;
            <Typography
              sx={{ display: 'inline', color: 'grey' }}
              component="span"
              variant="body2"
              color="text.primary">
              {option.Email}
            </Typography>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Secondary Engineer(s)"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSecondary ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />

      {/* <Box sx={{ marginTop: "25px" }}>
        <TextField
          fullWidth
          label="Notes"
          inputProps={{
            maxLength: CHARACTER_LIMIT
          }}
          id="notes"
          value={notes}
          multiline
          rows={4}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setNotes(event.target.value);
          }}
        helperText={`${notes.length}/${CHARACTER_LIMIT}`} />
      </Box> */}

      <Box sx={{ width: '100%', marginTop: "25px" }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={noteTabsValue} onChange={handleNoteTabsChange}>
            <Tab label="Tickets" {...a11yProps(0)} />
            <Tab label="Alerts" {...a11yProps(1)} />
            <Tab label="Notes" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={noteTabsValue} index={0}>
          <div>
            <MaterialReactTable columns={ticketsColumns} data={ticketsData} initialState={{ pagination: { pageIndex: 0, pageSize: 30 } }}
            // Disable Search, Filters, and Expand Features
            enableGlobalFilter={false} // Disable global search
            enableColumnFilters={false} // Disable column filters
            enableSorting={false} // Disable sorting
            enablePagination={true} // Disable pagination
            enableRowSelection={false} // Disable row selection
            enableExpanding={false} // Disable expand/collapse rows
            />
            
            {/* Dialog for Editing Rows */}
            <Dialog open={dialogOpen} onClose={handleDialogClose}>
              <DialogTitle>Ticket: Update Work Summary</DialogTitle>
              <DialogContent>
                <TextField
                  label="What was done"
                  name="detail1"
                  value={ticketsData[selectedRowIndex]?.detail1 || ''}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <TextField
                  label="What next"
                  name="detail2"
                  value={ticketsData[selectedRowIndex]?.detail2 || ''}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <Button onClick={handleDialogClose} color="primary" variant="contained" style={{ marginTop: '16px' }}>
                  Close
                </Button>
              </DialogContent>
            </Dialog>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={noteTabsValue} index={1}>
        <div>
            <MaterialReactTable columns={alarmsColumns} data={alarmsData} initialState={{ pagination: { pageIndex: 0, pageSize: 30 } }}
            // Disable Search, Filters, and Expand Features
            enableGlobalFilter={false} // Disable global search
            enableColumnFilters={false} // Disable column filters
            enableSorting={false} // Disable sorting
            enablePagination={true} // Disable pagination
            enableRowSelection={false} // Disable row selection
            enableExpanding={false} // Disable expand/collapse rows
            />
            
            {/* Dialog for Editing Rows */}
            <Dialog open={dialogAlarmDataOpen} onClose={handleDialogCloseAlarmData}>
              <DialogTitle>Alarm: Update Work Summary</DialogTitle>
              <DialogContent>
                <TextField
                  label="What was done"
                  name="detail1"
                  value={alarmsData[selectedRowIndexAlarmData]?.detail1 || ''}
                  onChange={handleInputChangeAlarmData}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <TextField
                  label="What next"
                  name="detail2"
                  value={alarmsData[selectedRowIndexAlarmData]?.detail2 || ''}
                  onChange={handleInputChangeAlarmData}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={4}
                />
                <Button onClick={handleDialogCloseAlarmData} color="primary" variant="contained" style={{ marginTop: '16px' }}>
                  Close
                </Button>
              </DialogContent>
            </Dialog>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={noteTabsValue} index={2}>
          <Box>
            <TextField
              fullWidth
              label="Notes"
              inputProps={{
                maxLength: CHARACTER_LIMIT
              }}
              id="notes"
              value={notesTab}
              multiline
              rows={4}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNotesTab(event.target.value);
              }}
            helperText={`${notesTab.length}/${CHARACTER_LIMIT}`} />
          </Box>
        </CustomTabPanel>
      </Box>

      <Box>
        <Button fullWidth className={classes.actionBtn1} sx={{marginTop: "30px", marginBottom: "15px"}} variant="contained" disabled={disableSubmitAction} onClick={onSubmitHandover}>Submit</Button>
        <Button fullWidth variant="outlined" onClick={onClickClear}>Clear</Button>
      </Box>
    </Box>
  );
}


function ItemsList(props: any) {
  const { isHandover, shiftEndTime, items, dispatch } = props;

  const classes = useStyles();

  /* var time = new Date();
  const currentTime = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
  const [shiftTime, meridian] = shiftEndTime.split(' ');
  const [shiftHour, shiftMinutes] = shiftTime.split(':');

  let finalShiftHour = shiftHour;
  if (shiftHour < 10) finalShiftHour = "0" + finalShiftHour;

  let finalShiftEndTime = finalShiftHour + ":" + shiftMinutes + " " + meridian;
  
  console.log(currentTime, finalShiftEndTime)
  if (currentTime > finalShiftEndTime) {
    console.log('current time is greater than shift end time');
  } else {
    console.log('time1 is equal to time2');
  } */


  // Get the current date
  const currentDate = new Date();

  // Get year, month, and day components
  const year = currentDate.getFullYear();
  // Months are 0-indexed, so add 1 to get the correct month
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');

  // Form the "yyyy-mm-dd" date string
  const formattedDate = `${year}-${month}-${day}`;

  const shiftTime = changeTimeZone(new Date(`${formattedDate} ${shiftEndTime}`));

  // console.log('Shift DATE: ', shiftTime)

  let enableHandover: boolean = false;

  if (!isHandover && shiftEndTime && isShiftOverdue(shiftTime)) {
    // The shift is overdue or in progress, so it can't be handed over
    console.log("Please handover");
    enableHandover = true;
  }

  return (
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      {items.map((item, index) => {
        return(
          <React.Fragment key={index}>
          <ListItem alignItems="flex-start" key={index}>
            <ListItemAvatar>
              <Avatar {...stringAvatar(item.Name)} />
            </ListItemAvatar>
            <ListItemText
              primary={item.Name}
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: 'inline' }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {item.Email}
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
          {items.length > 1 && (<Divider variant="inset" component="li" />)}
          </React.Fragment>
        )
      })}
      {/* {enableHandover && 
      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Button className={classes.actionBtn1} variant="contained" onClick={() => dispatch(SharedDialogActions.openDialog())}>Handover</Button>
      </Box>
      } */}
    </List>
  );
}

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string) {
  let nameChild = ""
  if (name.includes(" "))
    nameChild = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
  else
    nameChild = name[0]
  
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${nameChild}`,
  };
}


function changeTimeZone(date, timeZone="Asia/Kolkata") {
  if (typeof date === 'string') {
    return new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone,
      }),
    );
  }

  return new Date(
    date.toLocaleString('en-US', {
      timeZone,
    }),
  );
}

function isShiftOverdue(shiftTime: any) {
  const HANDOVER_GRACE_TIME_MINUTES = 60;
  //const HANDOVER_AFTER_GRACE_TIME_MINUTES = 60;
  const currentTime: any = changeTimeZone(new Date());

  // Calculate the time difference in milliseconds
  const timeDifferenceMs = shiftTime - currentTime;

  // Convert the time difference to minutes
  let timeDifferenceMinutes = Math.round(timeDifferenceMs / (1000 * 60));

  // console.log(`Time difference in minutes: ${shiftTime} ${currentTime} ${timeDifferenceMinutes}`);

  if (timeDifferenceMinutes <= 0 && Math.abs(timeDifferenceMinutes) <= HANDOVER_GRACE_TIME_MINUTES) return true;
  else if (timeDifferenceMinutes > 0 && (currentTime >= shiftTime || timeDifferenceMinutes <= HANDOVER_GRACE_TIME_MINUTES)) return true;
  else return false;


}

export default Dashboard;